import { atom, onMount } from 'nanostores';

export function createFullscreenStore() {
  const $fullscreenActive = atom<boolean>(false);
  onMount($fullscreenActive, () => {
    const onFullscreenChange = () => {
      if (!document.fullscreenElement && !document.webkitFullscreenElement) {
        // Fullscreen has been exited
        setFullscreen(false);
      }
    };

    globalThis.addEventListener('fullscreenchange', onFullscreenChange);
    globalThis.addEventListener('webkitfullscreenchange', onFullscreenChange);
    return () => {
      globalThis.removeEventListener('fullscreenchange', onFullscreenChange);
      globalThis.removeEventListener(
        'webkitfullscreenchange',
        onFullscreenChange,
      );
    };
  });

  function setFullscreen(active: boolean) {
    $fullscreenActive.set(active);
  }
  const $controlsVisible = atom<boolean>(true);
  function setControlsVisible(state: boolean) {
    $controlsVisible.set(state);
  }

  const $fullscreenControlsExpanded = atom<boolean>(true);
  function setFullscreenControlsExpanded(isExpanded: boolean) {
    $fullscreenControlsExpanded.set(isExpanded);
  }

  const $fullscreenSidebarVisible = atom<boolean>(false);
  function toggleFullscreenSidebarVisibility() {
    $fullscreenSidebarVisible.get()
      ? $fullscreenSidebarVisible.set(false)
      : $fullscreenSidebarVisible.set(true);
  }

  const $fullscreenSidebarAvailable = atom<boolean>(false);
  function setFullscreenSidebarAvailable(isSidebarAvailable: boolean) {
    $fullscreenSidebarAvailable.set(isSidebarAvailable);
  }

  return {
    $fullscreenActive,
    $fullscreenSidebarAvailable,
    $controlsVisible,
    $fullscreenControlsExpanded,
    $fullscreenSidebarVisible,
    setControlsVisible,
    setFullscreenControlsExpanded,
    setFullscreen,
    toggleFullscreenSidebarVisibility,
    setFullscreenSidebarAvailable,
  };
}
